import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("btb_token") || "";
export const setToken = (t) => localStorage.setItem("btb_token", t);
export const clearToken = () => localStorage.removeItem("btb_token");

export const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const apiErr = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return fallback;
};

export { axios };

export const startCheckout = async (lookup_key, email) => {
  const { data } = await axios.post(`${API}/payments/checkout`, { lookup_key, email, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
};

export const startCheckoutItems = async (items, email) => {
  const { data } = await axios.post(`${API}/payments/checkout`, { items, email, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
};
